import { useEffect, useRef, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const render = (html, userId) => api.post("/signatures/recipient-preview", {
  html_content: html, image_strategy: "external", user_id: userId || undefined,
}).then((r) => r.data.html);

/** Server-render two template versions with the reference user's data. */
export function useRenderedPair(leftHtml, rightHtml, userId, enabled) {
  const [pair, setPair] = useState({ left: "", right: "" });
  const [loading, setLoading] = useState(false);
  const requestId = useRef(0);

  useEffect(() => {
    const current = ++requestId.current;
    if (!enabled || leftHtml == null || rightHtml == null) return;
    setLoading(true);
    Promise.all([render(leftHtml, userId), render(rightHtml, userId)])
      .then(([left, right]) => { if (current === requestId.current) setPair({ left, right }); })
      .catch((e) => { if (current === requestId.current) toast.error(formatApiError(e, "No se pudo renderizar la comparación")); })
      .finally(() => { if (current === requestId.current) setLoading(false); });
  }, [leftHtml, rightHtml, userId, enabled]);

  return { ...pair, loading };
}
